import styled, {css, keyframes} from 'styled-components';
import {RowStyles, ColumnStyles} from './../../../../../../stories/core-components/Layouts/Layouts';

export const FilterLoaderWrap = styled.div`
  background: white;
  width: 100%;
  border-radius: 0.6rem;
`;

export const FilterMainHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  width: 100%;
  padding: 3rem 2rem;
  border-bottom: 1px solid #e1e7ee;
  justify-content: space-between;
  align-items: center;
`;
export const FilterTitle = styled.span(
  (props: ThemeProps<Theme>) => `
    font-family:${props.theme.font.fontFamily};
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    font-size: 1.8rem;
    font-weight: bold;
`,
);

export const ResetElink = styled.span(
  (props: ThemeProps<Theme>) => `
    ${RowStyles}
    color:#c5c5c5;
    font-size:${props.theme.font.custom(12)};
    font-family:${props.theme.font.fontFamily};
    font-weight:bold;
    
  `,
);

export const FilterBlock = styled.div`
  ${RowStyles}
  width:100%;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid #e1e7ee;
`;
export const FilterHeaderBlock = styled.div(
  (props: ThemeProps<Theme>) => `
    ${RowStyles}
    width:100%;
    justify-content:space-between;
    align-items:center;
  
  `,
);
export const FilterContentBlock = styled.div`
  ${ColumnStyles}
  flex-wrap: wrap;
  width: 100%;
  padding-top: 2rem;
`;

export const FilterHeaderTxt = styled.span(
  (props: ThemeProps<Theme>) => `
    
    font-size: 1.4rem;
    font-family: ${props.theme.font.fontFamily};
    font-weight: bold;
  `,
);
export const ResetLink = styled.span(
  (props: ThemeProps<Theme>) => `
    color: #c5c5c5;
    font-size: 1.2rem;
    font-family: {props.theme.font.fontFamily};
    
    
  `,
);
